// extracted by css-extract-rspack-plugin
export default {"Box_0":"FilterInputWrapper-module__Box_0__PsBHG8I","Box_1":"FilterInputWrapper-module__Box_1__BKQlxsU"};